/**
 * Workspace stoppen oder freigeben (Boards „Preisautomatik · Workspace stoppen“ und „Handy ·
 * Stoppen“): am Desktop die Bestätigung, am Handy ein Blatt von unten. Gestoppt berechnet und sendet
 * der Server für keinen Apartment mehr etwas; Buchungen und manuelle Werte bleiben, wie sie sind.
 */
import { BottomSheet, Button, ConfirmDialog } from '@/shared/components';
import { useMediaQuery } from '@/shared/hooks/useMediaQuery';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Der heutige Zustand: gestoppt heißt, die Bestätigung gibt frei. */
  killed: boolean;
  loading: boolean;
  onConfirm: () => void;
}

const TEXT = {
  stop: 'Gilt für alle Objekte und Apartments. Es wird nichts mehr berechnet oder gesendet; Buchungen und manuelle Werte bleiben unberührt.',
  enable:
    'Alle Apartments mit eingeschalteter Automatik werden ab dem nächsten Lauf wieder berechnet.',
};

export function OverviewStopDialog({ open, onOpenChange, killed, loading, onConfirm }: Props) {
  const mobile = useMediaQuery('(max-width: 767px)');
  const action = killed ? 'freigeben' : 'stoppen';
  const text = killed ? TEXT.enable : TEXT.stop;
  if (!mobile) {
    return (
      <ConfirmDialog
        open={open}
        onOpenChange={onOpenChange}
        title={`Preisautomatik für den ganzen Workspace ${action}?`}
        description={text}
        confirmLabel={`Workspace-weit ${action}`}
        variant={killed ? 'brand' : 'destructive'}
        loading={loading}
        onConfirm={onConfirm}
      />
    );
  }
  return (
    <BottomSheet
      open={open}
      onOpenChange={onOpenChange}
      title={`Für den ganzen Workspace ${action}?`}
      footer={
        <div className="flex flex-col gap-2">
          <Button
            variant={killed ? 'brand' : 'destructive'}
            className="h-[50px] w-full text-[15px]"
            loading={loading}
            onClick={onConfirm}
          >
            Workspace-weit {action}
          </Button>
          <Button
            variant="ghost"
            className="h-[50px] w-full text-[15px]"
            disabled={loading}
            onClick={() => onOpenChange(false)}
          >
            Abbrechen
          </Button>
        </div>
      }
    >
      <p className="text-ink-soft text-sm leading-normal">{text}</p>
    </BottomSheet>
  );
}
